import {useMemo} from "react";
import {useSelector} from "react-redux";

export default () => {

	const {
		checkoutBasket,
		checkoutBasketAdditionData,
		checkoutBasketCountry,
		checkoutBasketDiscounts,
		checkoutBasketExpiry,
		checkoutBasketId,
		checkoutBasketLoading,
		checkoutBasketUpsells,
		checkoutOrderVouchers
	} = useSelector(store => store);

	return useMemo(() => {

		return {
			checkoutBasket,
			checkoutBasketAdditionData,
			checkoutBasketCountry,
			checkoutBasketDiscounts,
			checkoutBasketExpiry,
			checkoutBasketId,
			checkoutBasketLoading,
			checkoutBasketUpsells,
			checkoutOrderVouchers
		};
	}, [
		checkoutBasket,
		checkoutBasketAdditionData,
		checkoutBasketCountry,
		checkoutBasketDiscounts,
		checkoutBasketExpiry,
		checkoutBasketId,
		checkoutBasketLoading,
		checkoutBasketUpsells,
		checkoutOrderVouchers
	]);

};
